import {
  OrderFinishedCargoOrdersUnbilledListItem,
  OrderFinishedCargoOrdersUnbilledListItemLackingRailyBillings,
} from "../../../../../../common/services/order/finished-cargo-orders/unbilled-list/order-finished-cargo-orders-unbilled-list";
import BillingsTaxiUnbilledOrderListingItem, {
  BillingsTaxiUnbilledOrderListingItemMissingBillingType,
} from "../../common/types/billings-taxi-unbilled-order-listing-item";
import BillingsTaxiUnbilledOrderListingItemStatus from "../../common/types/billings-taxi-unbilled-order-listing-item-status";

const createListingItemStatus = (
  responseDataItem: OrderFinishedCargoOrdersUnbilledListItem,
): BillingsTaxiUnbilledOrderListingItemStatus => {
  if (responseDataItem.isCancelled) {
    return BillingsTaxiUnbilledOrderListingItemStatus.CANCELLED;
  }

  return BillingsTaxiUnbilledOrderListingItemStatus.FINISHED;
};

const createListingItemMissingBillingTypes = (
  responseItemLackingRailyBillings: OrderFinishedCargoOrdersUnbilledListItemLackingRailyBillings[],
): BillingsTaxiUnbilledOrderListingItemMissingBillingType[] => {
  const missingBillingTypes: BillingsTaxiUnbilledOrderListingItemMissingBillingType[] =
    [];

  if (
    responseItemLackingRailyBillings.includes(
      OrderFinishedCargoOrdersUnbilledListItemLackingRailyBillings.CARGO_RAILY,
    )
  ) {
    missingBillingTypes.push(
      BillingsTaxiUnbilledOrderListingItemMissingBillingType.CARGO_WITH_RAILY,
    );
  }

  if (
    responseItemLackingRailyBillings.includes(
      OrderFinishedCargoOrdersUnbilledListItemLackingRailyBillings.RAILY_TAXI,
    )
  ) {
    missingBillingTypes.push(
      BillingsTaxiUnbilledOrderListingItemMissingBillingType.RAILY_WITH_TAXI,
    );
  }

  if (
    responseItemLackingRailyBillings.includes(
      OrderFinishedCargoOrdersUnbilledListItemLackingRailyBillings.TAXI_RAILY,
    )
  ) {
    missingBillingTypes.push(
      BillingsTaxiUnbilledOrderListingItemMissingBillingType.TAXI_WITH_RAILY,
    );
  }

  return missingBillingTypes;
};

const createListingItem = (
  responseDataItem: OrderFinishedCargoOrdersUnbilledListItem,
): BillingsTaxiUnbilledOrderListingItem => {
  return {
    clientName: responseDataItem.client.name,
    dispatchName: responseDataItem.dispatch,
    driversDisplayNames: responseDataItem.drivers,
    externalOrderId: responseDataItem.externalId,
    internalOrderId: responseDataItem.humanId,
    passengers: responseDataItem.passengers,
    routeAddresses: responseDataItem.rideAddresses,
    startDate: responseDataItem.startTime,
    status: createListingItemStatus(responseDataItem),
    taxiCorporations: responseDataItem.taxiCorporations,
    uuid: responseDataItem.uuid,
    missingBillingTypes: createListingItemMissingBillingTypes(
      responseDataItem.lackingRailyBillings,
    ),
  };
};

const createListingItems = (
  responseDataItems: OrderFinishedCargoOrdersUnbilledListItem[],
): BillingsTaxiUnbilledOrderListingItem[] => {
  return responseDataItems.map(createListingItem);
};

const billingsTaxiUnbilledOrderListingByRailyFactory = {
  createListingItems,
};

export default billingsTaxiUnbilledOrderListingByRailyFactory;
